import { localDatabaseUrls } from "../backend/constants";
import { getJWTToken } from "../shared/fetchWrapper/fetchWrapper";
import { postAPI } from "../backend/commons";
import AlertManager from "../shared/Alert/Alert";

export const buildDraftDCCostBatchPayload = (selectedRows = [], tokenInfo = {}, comments = "Need to review later") => ({
  approvedBy: tokenInfo.username || "",
  comments,
  targetItems: selectedRows.map((row) => ({
    sku: row?.parsedSku || row?.sku || row?.skuId || row?.id || "",
    hqLine: row?.hqLine || "",
  })),
});

export const draftDCCostBatch = async (batchId, selectedRows = [], { comments, successMessage } = {}) => {
  if (!batchId) {
    AlertManager.error("Unable to draft DC cost batch.", { contactSupport: false });
    return null;
  }

  if (!Array.isArray(selectedRows) || !selectedRows.length) {
    AlertManager.warning("Select one or more items to draft.", { contactSupport: false });
    return null;
  }

  const tokenInfo = await getJWTToken();

  if (!tokenInfo) {
    window.location.href = "/";
    return null;
  }

  const apiUrl = `${localDatabaseUrls.baseURL}api/v1/dc-cost/draft/${encodeURIComponent(batchId)}`;
  const requestBody = buildDraftDCCostBatchPayload(selectedRows, tokenInfo, comments || "Need to review later");
  const body = new Blob([JSON.stringify(requestBody)], { type: "application/json" });

  try {
    const response = await postAPI(apiUrl, body, tokenInfo);

    if (response?.ok) {
      AlertManager.success(successMessage || "Selected items saved as draft successfully.", {
        contactSupport: false,
      });
      return response;
    }

    const errorData = await response?.json?.().catch(() => ({}));
    throw new Error(errorData?.message || "Unable to draft selected items.");
  } catch (error) {
    AlertManager.error(error?.message || "Unable to draft selected items.", { contactSupport: false });
    return null;
  }
};

export default draftDCCostBatch;
